import React from "react";

function DataAnalytics() {
  return <div>DataAnalytics</div>;
}

export default DataAnalytics;
